import { Article } from '../types';

export const guideMiniGridsOffGrid: Article = {
    id: 'guide-mini-grids-off-grid',
    title: 'The Beginner\'s Guide to Mini-Grids and Off-Grid Solar in Nigeria',
    slug: 'beginners-guide-mini-grids-off-grid-solar-nigeria',
    excerpt: 'Understand the difference between off-grid, on-grid, and mini-grid solar systems, and discover which is best for your community.',
    category: 'Renewable Energy',
    date: 'March 18, 2026',
    readTime: '2 min read',
    author: 'power.ng Research',
    trending: false,
    keywords: ['mini-grid Nigeria', 'off-grid solar', 'rural electrification', 'solar definitions', 'net metering'],
    metaDescription: 'Learn the differences between mini-grids, off-grid systems, and interconnected solar setups in Nigeria with our comprehensive beginner\'s glossary.',
    content: `## Quick Answer: What is a Mini-Grid?
A **Mini-grid** is an independent, decentralized electricity network that can generate and distribute power to a specific localized group of customers (like an estate or a village), avoiding the national grid. An **Off-grid** system is a private solar setup that powers a single house entirely independent of any external grid.

---

## Demystifying Solar Terminology

As Nigeria moves away from the centralized national power grid, the terminology around renewable energy can get confusing. Here is your definitive glossary to understand Nigeria’s evolving energy architecture in 2026.

### 1. Off-Grid Solar
**What is it?** A solar and battery system completely disconnected from the National Grid (DisCo). 
**Use Case:** Common in isolated rural areas, farms, or for homeowners who have decided to cut their DisCo cables permanently and rely 100% on their own generated power.

### 2. On-Grid Solar (Grid-Tied)
**What is it?** A solar system that is connected to the National Grid but **does not use batteries.** When the sun shines, the house uses solar power. At night, it uses DisCo power.
**Use Case:** Ideal for offices, factories, and schools that operate strictly during daytime hours and want to save on battery costs.

### 3. Hybrid Solar Systems
**What is it?** The most popular setup in Nigeria. It uses panels, batteries, and is also connected to the National Grid or a generator. The inverter intelligently mixes the power sources.
**Use Case:** Middle-class homes and businesses that want maximum reliability by drawing from solar, grid, and generator seamlessly.

### 4. Mini-Grids (Isolated)
**What is it?** A massive centralized solar array and battery bank built in a village or community. Wires are run from this central hub to the individual houses in the community, and each house gets a prepaid meter.
**Use Case:** Rural Electrification. It brings bankable, clean power to villages the national grid will never reach.

### 5. Interconnected Mini-Grids
**What is it?** Similar to a mini-grid, but placed in urban areas (like a large market or residential estate) and it cooperates with the local DisCo. It uses the DisCo's existing wires to distribute solar power when the grid is down.
**Use Case:** Commercial hubs like Wuse Market or Alaba International.

### 6. Net Metering
**What is it?** A policy that allows a homeowner with excess solar power to send that electricity *back* into the National Grid. The DisCo then credits the homeowner's electricity bill.
**Use Case:** Currently in early policy stages in Nigeria under NERC regulations, aimed at encouraging massive solar adoption in cities.`
  };
